import React from "react";
import CityAccodian from "./CityAccodian";

export default function DiscountsSectionCity(props) {

  return (
    <div className="discounts_section">
      <h1>{props?.DiscountsSectionCity?.content?.Header[0]?.headline}</h1>
      <p className="title-bottom-text">
        {props?.DiscountsSectionCity?.content?.Header[0]?.subheadline}
      </p>
      <div
        className="panel-group"
        id="accordion"
        role="tablist"
        aria-multiselectable="true"
      >
        {" "}
        {props?.DiscountsSectionCity?.content?.Items?.map((item, index) => {
          return (
            <div key={index}>
              <CityAccodian item={item} index={index} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
